import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'
import {addParamsToUrl, athubAxios} from "@/util";

const department = new RestResource({server: ORGANIZATION_SERVER, resource: 'department'});

department.invalidate = (id, athubConfig) => {
    return athubAxios.put([department.server, department.resource, id, 'invalid'].join('/'), null, athubConfig);
};

department.revalidate = (id, athubConfig) => {
    return athubAxios.put([department.server, department.resource, id, 'valid'].join('/'), null, athubConfig);
};

department.findByCode = (code, athubConfig) => {
    return athubAxios.get(addParamsToUrl([department.server, department.resource, 'code'].join('/'), {
        code: code
    }), athubConfig);
};

department.findByName = (name, athubConfig) => {
    return athubAxios.get(addParamsToUrl([department.server, department.resource, 'name'].join('/'), {
        name: name
    }), athubConfig);
};

export default department;